import React, { useEffect, useRef, useState } from 'react';
import { METRIC_GRAINS, METRIC_GRAIN_LABEL, type MetricGrain } from './clientViewTokens';

interface Props {
  value: MetricGrain;
  onChange: (next: MetricGrain) => void;
  disabled?: boolean;
}

/**
 * The time grain every card KPI, sort and metric filter reads. One grain drives the
 * whole board — the card shows one reading, so letting sort and filter run on a
 * different window is what left "Listed" reconcilable against nothing on the card.
 */
export const MetricGrainControl: React.FC<Props> = ({ value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  return (
    <div className="cv-sort-control" ref={wrapRef}>
      <button
        type="button"
        className="cv-sort-btn"
        aria-haspopup="dialog"
        aria-expanded={open}
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        title="The time window the card KPIs, sort and metric filters all read"
      >
        Grain: {METRIC_GRAIN_LABEL[value]} ▾
      </button>
      {open && (
        <div className="cv-sort-menu" role="dialog" aria-label="Metric time grain">
          <div className="cv-sort-menu-head">
            <span>Read metrics over</span>
          </div>
          <ul className="cv-grain-rows">
            {METRIC_GRAINS.map((g) => (
              <li key={g}>
                <button
                  type="button"
                  className={`cv-grain-row${g === value ? ' is-active' : ''}`}
                  onClick={() => { onChange(g); setOpen(false); }}
                  aria-current={g === value}
                >
                  <span className="cv-grain-check">{g === value ? '✓' : ''}</span>
                  <span>{METRIC_GRAIN_LABEL[g]}</span>
                </button>
              </li>
            ))}
          </ul>
          <p className="cv-grain-note">
            Core standing and To Core are only calculated on the 3-month windows, so
            they stay on Period whatever you pick here.
          </p>
        </div>
      )}
    </div>
  );
};
